export class InvoiceFormData {
    constructor() {
        this.documentType = '380';
        this.documentIdentifier = '';
        this.documentIssueDate = '';
        this.customerNumber = '';
        this.deliveryDate = '';
        this.roundingAmount = 0;
        this.tvsCustomerNumber = '';
        this.companyName = '';
        this.address1 = '';
        this.address2 = '';
        this.address3 = '';
        this.zipCode = '';
        this.cityName = '';
        this.country = 'CH';
    }
    documentType: '380' | '381';
    documentIdentifier: string;
    documentIssueDate: string;
    customerNumber: string;
    deliveryDate: string;
    orderDate?: string | null;
    orderReference?: string | null;
    roundingAmount: number;
    tvsCustomerNumber: string;
    companyName: string;
    address1: string;
    address2?: string | null;
    address3?: string | null;
    zipCode: string;
    cityName: string;
    country: string;
    totalExclVat: number;
    totalInclVat: number;
}

export class InvoicePosition {
    constructor() {
        this.SupplierArticleNumber = '';
        this.productName = '';
        this.quantity = 1;
        this.unitOfMeasurement = 'PCE';
        this.unitPrice = 0;
        this.vatRate = 0;
        this.taxableAmount = 0;
        this.taxAmountPayable = 0;
    }
    SupplierArticleNumber: string;
    VetpointArticleNumber?: string | null;
    gtin?: string | null;
    productName: string;
    quantity: number;
    unitOfMeasurement: string;
    unitPrice: number;
    vatRate: number;
    taxableAmount: number;
    taxAmountPayable: number;
}

export class SupplierInformation {
    constructor() {
        this.tvsLieferantennummer = 0;
        this.mwstNummer = '';
        this.firma = '';
        this.adresszeile1 = '';
        this.plz = 0;
        this.ort = '';
        this.land = 'CH';
    }
    tvsLieferantennummer: number;
    mwstNummer: string;
    firma: string;
    adresszeile1: string;
    adresszeile2?: string;
    adresszeile3?: string;
    plz: number;
    ort: string;
    land: string;
}

export class VATSummary {
    constructor(rate = 0) {
        this.vatRate = rate;
        this.taxableAmount = 0;
        this.taxAmountPayable = 0;
    }
    vatRate: number;
    taxableAmount: number;
    taxAmountPayable: number;
}

export class VetdataInvoiceData {
    constructor() {
        this.formData = new InvoiceFormData();
        this.positions = [];
        this.supplierInfo = new SupplierInformation();
        this.totalTaxableAmount = 0;
        this.totalInclVat = 0;
        this.vatSummary = [];
    }
    formData: InvoiceFormData;
    positions: InvoicePosition[];
    supplierInfo: SupplierInformation;
    totalTaxableAmount: number;
    totalInclVat: number;
    vatSummary: VATSummary[];
}
